import { render } from "./SFaceCheckinDisp.vue?vue&type=template&id=3c3301a9&scoped=true"
import script from "./SFaceCheckinDisp.vue?vue&type=script&lang=js"
export * from "./SFaceCheckinDisp.vue?vue&type=script&lang=js"

import "./SFaceCheckinDisp.vue?vue&type=style&index=0&id=3c3301a9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3c3301a9"

export default script